import { TemplateSourceFilters } from 'ContentUtils/constants/TemplateSourceFilters';
import { TemplateFilters } from 'ContentUtils/constants/ThemeFilters';
import { ThemeSortingTypes } from 'ContentUtils/constants/ThemeSortingTypes';
export const ROOT_FOLDER = 'root';
export const makeFetchTemplateQueryParams = (filters, limitPerPage) => {
  const {
    search,
    templateTypeIds,
    themePath,
    page = 1,
    folderName = ROOT_FOLDER,
    sorting = ThemeSortingTypes.MOST_USED,
    sourceFilter = TemplateSourceFilters.ALL,
    type = TemplateFilters.ALL_TEMPLATES,
    hasDndArea = null
  } = filters;
  return {
    sorting,
    templateTypeIds,
    themePath,
    type: type === TemplateFilters.ALL_TEMPLATES ? null : type,
    folderName: folderName === ROOT_FOLDER ? null : folderName,
    sourceFilter: sourceFilter === TemplateSourceFilters.ALL ? null : sourceFilter,
    name: search,
    limit: limitPerPage,
    offset: (page - 1) * limitPerPage,
    excludeUnusedInMemory: !themePath,
    hasDndArea
  };
};